import { defineComponent } from '~/utils/alpine_types'

export const imageUpload = defineComponent(() => ({
  filename: window.I18n.no_file,
  destroyed: false,
  uploaded: false,
  origImageExists: false,
  origSrc: undefined as unknown as string,
  imageEl: undefined as unknown as HTMLImageElement,
  inputEl: undefined as unknown as HTMLInputElement,

  init() {
    // Wait for Alpine to finish rendering completely so that $refs is available
    this.$nextTick(() => {
      this.imageEl = this.$refs.imageEl as HTMLImageElement
      this.inputEl = this.$refs.inputEl as HTMLInputElement
      this.origSrc = this.imageEl.src
      this.origImageExists = this.origSrc !== 'data:,'
      this.inputEl.addEventListener('change', () => this.upload())
    })
  },

  // Remove the original image
  destroy() {
    this.uploaded = false
    this.imageEl.src = 'data:,'
    this.inputEl.value = ''
  },

  // Read the uploaded image file and add it to 'imageEl'
  upload() {
    const files = this.inputEl.files
    if (!files) return

    const imageFile = files[0]

    if (!imageFile) {
      this.filename = window.I18n.no_file
      return
    }

    const reader = new FileReader()
    reader.onload = () => (this.imageEl.src = reader.result as string)
    reader.readAsDataURL(imageFile)

    this.filename = imageFile.name
    this.uploaded = true
    this.destroyed = false
  },

  // Empty input's value and reset image to original source
  undoUpload() {
    this.inputEl.value = ''
    this.imageEl.src = this.origSrc
    this.uploaded = false
    this.destroyed = false
    this.filename = window.I18n.no_file
  },
}))
